import './LandfillCard.scss';

import React from 'react';

import { Button } from '~/@components/Button';
import { LocalizableText } from '~/@components/LocalizableText';
import { getBem } from '~/@sochi-components/@bem';
import { LocationMarkerIcon, UserRoundFilledIcon } from '~/@sochi-components/Icons';
import { IHomePageLandfill } from '~/@user-store/homePageMap';
import { isOwnLandfill } from '~/@user-store/homePageMap/homePageMap.utils';
import { SochiReceivers } from '~/@views/UserView/common/SochiReceivers';
import { getHighlightFunc } from '~/utils';
import { fmtCoordinates } from '~/utils/numbers';

type LandfillCardProps = {
    landfill: IHomePageLandfill;
    onOpen?: (landfill: IHomePageLandfill) => void;
    isSelected: boolean;
    onActivate?: (landfill: IHomePageLandfill) => void;
    highlightText?: string;
};

export class LandfillCard extends React.PureComponent<LandfillCardProps> {
    bem = getBem(this);
    openLandfill = (e: React.MouseEvent) => {
        const { onOpen, landfill } = this.props;
        onOpen && onOpen(landfill);

        e.stopPropagation();
    };

    render() {
        const { landfill, highlightText = '' } = this.props;
        const { element, block } = this.bem;
        const highlight = getHighlightFunc(highlightText);

        return (
            <div className={block({ isSelected: this.props.isSelected })}>
                <div className={element('title')}>
                    <div className={element('information')}>
                        <div className={element('name')} title={landfill.name}>
                            {highlight(landfill.name)}
                        </div>
                    </div>
                </div>
                <div className={element('body')}>
                    {isOwnLandfill(landfill) && (
                        <div className={element('section')}>
                            <UserRoundFilledIcon className={element('section-icon')} />
                            <SochiReceivers receivers={landfill.receivers || []} highlightText={highlightText} />
                        </div>
                    )}
                    <div
                        className={element('section', { isClickable: !!this.props.onActivate })}
                        onClick={() => this.props.onActivate?.(landfill)}>
                        <LocationMarkerIcon className={element('section-icon')} />
                        <div className={element('location')}>
                            <div>{highlight(landfill.location.text)}</div>
                            <div>{fmtCoordinates(landfill.location)}</div>
                        </div>
                    </div>
                </div>
                {this.props.onOpen && (
                    <div className={element('action')}>
                        <Button variant="outlined" color="primary" onClick={this.openLandfill}>
                            <LocalizableText code={'openLandfill'} />
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}
